/**
* Testimonials Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonials Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'testimonials-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.testimonials-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--testimonials-slider' )[0], {
          type: 'loop',
          pagination: false,
          arrows: true,
          perPage: 1,
          perMove: 1,
        } );

        splide.mount();
      } );

      $( '.testimonials-slider .text-image' ).each( function( key, val ) {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 75%',
            scrub: 0,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( val ).addClass( 'is-loaded' );
              }
            },
            onEnter: function() {
              $( val ).addClass( 'is-loaded' );
            },
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonials-slider', COMPONENT );
} )( app );
